<template>
  <div class="map-col col keep-padding keep-margin">
    <div class="map">
      <div class="map-title-box" @click.prevent="mapClick">
        <div class="map-name">{{map.name}}</div>
        <a :href="map.url" target="_blank" class="map-link">
          <span v-if="showPdf">PDF</span>
          <span v-if="showInteractive">{{ $t('Interactive') }}</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Map',
  props: ['map', 'index'],
  components: { },
  data() {
    return {
      expanded: false,
    };
  },
  computed: {
    showPdf() {
      return this.map.url.toLowerCase().indexOf('pdf') > 0 || this.map.isPDF == true;
    },
    showInteractive() {
      return !this.showPdf && this.map.showLinkText !== false;
    },
  },
  methods: {
    mapClick() {
      window.open(this.map.url, '_blank');
    },
  },
};
</script>

<style lang="scss" scoped>
  #dashboard {
    .map-col {
      background-color: $white;
      margin-bottom: 20px;
      position: relative;
      width: 100%;
      border-radius: 3px 3px 3px 3px;
      &:before {
        background-color: $open-tab-highlight;
        content: '';
        display: block;
        height: 100%;
        width: 3px;
        position: absolute;
        border-radius: 3px 0 0 3px;
      }
      .map {
        cursor: pointer;
        line-height: 100%;
        padding: 21px 15px 17px;
        max-width: 100%;
        width: 100%;
        @media (min-width: $tablet) {
          display: flex;
          flex: 1;
        }
      }
      .map-title-box {
        display: inline-block;
        width: 100%;
      }
      .map-name {
        color: $dark-gray;
        display: inline-block;
        font-family: $base-font-semibold;
        font-weight: 600;
        font-size: 14px;
        line-height: 1.2;
        letter-spacing: 0.2px;
        margin-right: 10px;
        max-width: 75%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        @media (min-width: $tablet) {
          font-size: 22px;
        }
      }
      .map-link {
        display: block;
        color: $dark-gray;
        float: right;
        font-size: 12px;
        font-weight: 300;
        line-height: 1.2;
        letter-spacing: 0.15px;
        margin-top: 3px;
        padding: 1px 0 0 0;
        @media (min-width: $tablet) {
          background: url('~@/assets/icons/right-arrow.svg') no-repeat center right;
          background-size: contain;
          font-size: 16px;
          height: 20px;
          padding: 1px 20px 0 0;
        }
      }
    }
  }
</style>


<i18n locale="fr-ca">
{
  "Interactive": "Carte interactive"
}
</i18n>
